// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__gCZgG","title":"AfterBackImages_title__1rN8k","images":"AfterBackImages_images__2IrvB"};